import {
  BRAND_ALL,
  BRAND_GET,
  BRAND_DEL,
  BRAND_PUT,
  BRAND_POST,
  BRAND_LOADING,
  BRAND_ERROR,
} from '../types';

import api from '../../../utils/functions/api';

export const brandCreate = (payload) => async (dispatch) => {
  try {
    dispatch({ type: BRAND_LOADING });
    const { data } = await api.post(`${process.env.REACT_APP_API_URL}/brand`, {
      ...payload,
    });
    dispatch({ type: BRAND_POST, payload: data });
  } catch (error) {
    console.error(error);
    dispatch({ type: BRAND_ERROR });
    throw new Error(error);
  }
};

export const brandAll = (params) => async (dispatch) => {
  try {
    const { name = '', size = '', page = 1 } = params;
    const { data, status } = await api.get(
      `${process.env.REACT_APP_API_URL}/brand?name=${name}&size=${size}&page=${page}`,
    );
    if (status === 200) {
      dispatch({ type: BRAND_ALL, payload: data });
    }
  } catch (error) {
    console.error(error);
    dispatch({ type: BRAND_ERROR });
    throw new Error(error);
  }
};

export const brandGet = (id) => async (dispatch) => {
  try {
    const { data, status } = await api.get(
      `${process.env.REACT_APP_API_URL}/brand/${id}`,
    );
    if (status === 200) {
      dispatch({ type: BRAND_GET, payload: data });
    }
  } catch (error) {
    console.error(error);
    dispatch({ type: BRAND_ERROR });
    throw new Error(error);
  }
};

export const brandPut = (id, payload) => async (dispatch) => {
  try {
    dispatch({ type: BRAND_LOADING });
    const { data } = await api.put(
      `${process.env.REACT_APP_API_URL}/brand/${id}`,
      payload,
    );
    dispatch({ type: BRAND_PUT, payload: data });
  } catch (error) {
    console.error(error);
    dispatch({ type: BRAND_ERROR });
    throw new Error(error);
  }
};
export const brandDelete = (id) => async (dispatch) => {
  try {
    dispatch({ type: BRAND_LOADING });
    const { data } = await api.delete(
      `${process.env.REACT_APP_API_URL}/brand/${id}`,
    );
    dispatch({ type: BRAND_DEL, payload: data });
  } catch (error) {
    console.error(error);
    dispatch({ type: BRAND_ERROR });
    throw new Error(error);
  }
};
